/* eslint-disable react/jsx-indent-props */
/* eslint-disable react/jsx-first-prop-new-line */
/* eslint-disable no-unused-vars */
/* eslint-disable react/jsx-no-bind */
/* eslint-disable max-len */
/* eslint-disable arrow-body-style */

import { ArrowLeftCircleIcon, DocumentIcon } from "@heroicons/react/24/solid";
import { Button, Container, Nav } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import PropTypes from "prop-types";
import { useMemo } from "react";

import { ReactComponent as HelpIcon } from "../../assets/icons/Help_Icon.svg";
import { useUser } from "../UserContext";

const ProfileNav = ({ handleClose }) => {
	const { respondent } = useUser();
	const profileCompleted = useMemo(() => respondent?.profilecomplete || respondent?.weqProfile?.profilestatus === "completed" || respondent?.weqProfile?.profilestatus === "review", [respondent]);
	return (
		<Container className="profile__nav bg-primary">
			<div className="logo-container profile__sidebar-section align-items-center d-flex justify-content-between">
				<img 
					alt="LOGO"
					className="logo"
					height="152"
					src="/eqqo_logo.png"
					width="472"
				/>
				<Button className="nav-menu-button" onClick={handleClose}>X</Button>
			</div>
			<Nav as="nav" className="profile__sidebar-section flex-column fs-16 px-0" defaultActiveKey="/profile/dashboard">
				<Nav.Item>
					<NavLink className="nav-link text-white" to="/profile/dashboard">
						<DocumentIcon />
						{
							respondent && profileCompleted
								? <span>Dashboard</span>
								: <span>Instructions</span>
						}
					</NavLink>
				</Nav.Item>
				{ respondent && profileCompleted ?
					(<Nav.Item>
						<NavLink className="nav-link text-white" to="/report/introduction">
							<DocumentIcon />
							My EQQO Report
						</NavLink>
					</Nav.Item>
					) : null }
			</Nav>
			<div className="profile__sidebar-section">
				<NavLink className="nav-link text-white" to="/profile/help">
					<HelpIcon />
					Help
				</NavLink>
			</div>
			<Nav.Item className="mt-auto profile__sidebar-section">
				<NavLink className="nav-link text-white" to="/logout">
					<ArrowLeftCircleIcon height={24} width={24} />
					Logout
				</NavLink>
			</Nav.Item>
		</Container>
	);
};


ProfileNav.propTypes = {
	handleClose: PropTypes.func,
};

ProfileNav.defaultProps = {
	handleClose: null
}

export default ProfileNav;
